import React from 'react';

function DownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#4A4A4A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.05"
        d="M1 1l4 4-4-4zm4 4l4-4-4 4z"
      />
    </svg>
  );
}

export default DownArrow;
